import {createAction} from 'redux-actions'
import * as ActionTypes from './actionTypes'
import {
    getColumnsOrder as getColumnsOrderFromTable,
    getFilteredColumnsOrder as getFilteredColumnsOrderFromTable,
    getShownColumns as getShownColumnsFromTable,
    getTasksSorting,
} from '../selectors'
import {getColumnsOrder, getSelectedColumns} from './selectors'
import {arrayToSet} from "../../../atUtils"
import {changeTasksSortingAction, setColumnsOrder as setTableColumnsOrder, setColumnsShown as setTableColumnsShown} from '../actions'
import {savePageSettings} from '../../common/actions'
import {TaskSortBy} from '../../constants'
import {isBTYEnabled, isESTEnabled} from '../../../features/selectors'
import {isSortByColumnUnavailable} from './utils'

export const setColumnsOrder = createAction(ActionTypes.ORDER_SET)

export const setSelected = createAction(ActionTypes.SELECTED_SET)

export const changeColumnSelection = (column, selected) => (dispatch, getState) => {
    const selectedColumns = {...getSelectedColumns(getState())}

    if (selected)
        selectedColumns[column] = selected
    else
        delete selectedColumns[column]

    dispatch(setSelected(selectedColumns))
}

export const changeColumnOrder = (id, newIndex) => (dispatch, getState) => {
    let order = getColumnsOrder(getState())
    order = order.filter(column => column !== id)
    order.splice(newIndex, 0, id)
    dispatch(setColumnsOrder(order))
}


export const beforeOpen = () => (dispatch, getState) => {
    const order = getFilteredColumnsOrderFromTable(getState())
    const shown = getShownColumnsFromTable(getState())
    const shownSet = arrayToSet(shown)
    dispatch(setColumnsOrder(order))
    dispatch(setSelected(shownSet))
}


export const saveChanges = () => (dispatch, getState) => {
    const state = getState()
    dispatch(restoreAndSetTableColumnsOrder())
    const selectedMap = getSelectedColumns(state)
    dispatch(setTableColumnsShown(Object.keys(selectedMap)))
    dispatch(afterClose())

    if (isSortByColumnUnavailable(getTasksSorting(state), selectedMap)) {
        //change sorting, reload tasks and save settings
        dispatch(changeTasksSortingAction({by: TaskSortBy.TASK, asc: true}))
    } else {
        //save settings only without reloading tasks
        dispatch(savePageSettings())
    }
}


export const afterClose = () => (dispatch) => {
    dispatch(setSelected({}))
    dispatch(setColumnsOrder([]))
}

export const restoreAndSetTableColumnsOrder = () => (dispatch, getState) => {
    const state = getState()
    const filteredOrder = getColumnsOrder(state)
    const curTableOrder = [...getColumnsOrderFromTable(state)]
    const estEnabled = isESTEnabled(state)
    const btyEnabled = isBTYEnabled(state)

    let selectorOrderIndex = 0
    for (let i = 0; i < curTableOrder.length; i++) {
        if (curTableOrder[i] === TaskSortBy.ESTIMATE && !estEnabled)
            continue
        if (curTableOrder[i] === TaskSortBy.TYPE_OF_WORK && !btyEnabled)
            continue
        curTableOrder[i] = filteredOrder[selectorOrderIndex++]
    }

    dispatch(setTableColumnsOrder(curTableOrder))
}


// WEBPACK FOOTER //
// ./web/js/taskManagement/tasksTable/configurationMenu/actions.js